<div class="p-6 rounded-lg bg-white shadow-lg">
  <div
    class="flex flex-col text-sigecom-gray"
    *ngIf="simpleStepParametrization$ | async as info"
  >
    <b class="text-xl flex text-sigecom-info gap-4">{{ info.petTxNome | uppercase}}</b>
    <div class="flex gap-2">
      <div class="flex gap-2 items-center">
        <b>Evento:</b>
        <p>{{ info.eveTxNome }}</p>
        <div class="my-2 h-4 w-0.5 bg-sigecom-gray"></div>
      </div>
      <div class="flex gap-2 items-center">
        <b>Bloco:</b>
        <p>{{ info.bloTxNome }}</p>
        <div class="my-2 h-4 w-0.5 bg-sigecom-gray"></div>
      </div>
      <div class="flex gap-2 items-center">
        <b>Competição:</b>
        <p>{{ info.comTxNome }}</p>
      </div>
    </div>
    <div class="flex gap-2">
      <div class="flex gap-2 items-center">
        <b>Formato da fase:</b>
        <p>{{ info.formatoInfo }}</p>
        <div class="my-2 h-4 w-0.5 bg-sigecom-gray"></div>
      </div>
      <div class="flex gap-2 items-center">
        <b>Categoria:</b>
        <p>{{ info.categoriaInfo }}</p>
      </div>
    </div>
  </div>
</div>
